// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-label {
  z-index: 10;
}

ion-item {
  border-radius: 8px;
  border-width: 2px;
  border-style: solid;
  border-color: #ffbe00;
  background-color: white !important;
}

.popover-content {
  width: 457px !important;
}

.showpointer {
  cursor: pointer;
}

.iconBtn:hover {
  background: var(--ion-color-danger-shade);
  color: var(--ion-color-medium-contrast);
  transition: background 0.1s, color 0.1s;
}

.iconBtn {
  border-radius: 1rem;
  color: var(--ion-color-danger);
  transition: background 0.5s, color 0.5s;
}

.errorbackdg {
  background: var(--ion-color-danger-tint) !important;
}

.warningbackdg {
  background: var(--ion-color-primary-tint) !important;
}

.inset {
  border-style: inset;
  border-width: 2px;
  border-radius: 10px;
  margin-bottom: 10px;
  padding: 10px;
}

ion-select {
  height: 55px;
  border-width: 3px !important;
}

ion-button {
  max-width: 260px;
  margin-left: auto;
  margin-right: auto;
}

ion-toggle {
  --background: #9c9c9c;
  --background-checked: #00a9bf71;
  --handle-background: white;
  --handle-background-checked: #00a9bf;
}

.short-description-textarea {
  height: 88px;
  min-height: 88px;
  max-height: 88px;
}

.activity-description-textarea {
  min-height: 88px;
}

.job-description-textarea {
  min-height: 132px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkZGpvYi5wYWdlLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxXQUFBO0FBQ0Y7O0FBQ0E7RUFDRSxrQkFBQTtFQUNBLGlCQUFBO0VBQ0EsbUJBQUE7RUFDQSxxQkFBQTtFQUNBLGtDQUFBO0FBRUY7O0FBQUE7RUFDRSx1QkFBQTtBQUdGOztBQURBO0VBQ0UsZUFBQTtBQUlGOztBQUZBO0VBQ0UseUNBQUE7RUFDQSx1Q0FBQTtFQUNBLHVDQUFBO0FBS0Y7O0FBSEE7RUFDRSxtQkFBQTtFQUNBLDhCQUFBO0VBQ0EsdUNBQUE7QUFNRjs7QUFKQTtFQUNFLG1EQUFBO0FBT0Y7O0FBTEE7RUFDRSxvREFBQTtBQVFGOztBQUxBO0VBQ0UsbUJBQUE7RUFDQSxpQkFBQTtFQUNBLG1CQUFBO0VBQ0EsbUJBQUE7RUFDQSxhQUFBO0FBUUY7O0FBTEE7RUFDRSxZQUFBO0VBQ0EsNEJBQUE7QUFRRjs7QUFMQTtFQUNFLGdCQUFBO0VBQ0EsaUJBQUE7RUFDQSxrQkFBQTtBQVFGOztBQUVBO0VBQ0UscUJBQUE7RUFDQSwrQkFBQTtFQUVBLDBCQUFBO0VBQ0Esb0NBQUE7QUFBRjs7QUFHQTtFQUNFLFlBQUE7RUFDQSxnQkFBQTtFQUNBLGdCQUFBO0FBQUY7O0FBR0E7RUFDRSxnQkFBQTtBQUFGOztBQUdBO0VBQ0UsaUJBQUE7QUFBRiIsImZpbGUiOiJhZGRqb2IucGFnZS5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiaW9uLWxhYmVsIHtcbiAgei1pbmRleDogMTA7XG59XG5pb24taXRlbSB7XG4gIGJvcmRlci1yYWRpdXM6IDhweDtcbiAgYm9yZGVyLXdpZHRoOiAycHg7XG4gIGJvcmRlci1zdHlsZTogc29saWQ7XG4gIGJvcmRlci1jb2xvcjogI2ZmYmUwMDtcbiAgYmFja2dyb3VuZC1jb2xvcjogd2hpdGUgIWltcG9ydGFudDtcbn1cbi5wb3BvdmVyLWNvbnRlbnQge1xuICB3aWR0aDogNDU3cHggIWltcG9ydGFudDtcbn1cbi5zaG93cG9pbnRlciB7XG4gIGN1cnNvcjogcG9pbnRlcjtcbn1cbi5pY29uQnRuOmhvdmVyIHtcbiAgYmFja2dyb3VuZDogdmFyKC0taW9uLWNvbG9yLWRhbmdlci1zaGFkZSk7XG4gIGNvbG9yOiB2YXIoLS1pb24tY29sb3ItbWVkaXVtLWNvbnRyYXN0KTtcbiAgdHJhbnNpdGlvbjogYmFja2dyb3VuZCAwLjFzLCBjb2xvciAwLjFzO1xufVxuLmljb25CdG4ge1xuICBib3JkZXItcmFkaXVzOiAxcmVtO1xuICBjb2xvcjogdmFyKC0taW9uLWNvbG9yLWRhbmdlcik7XG4gIHRyYW5zaXRpb246IGJhY2tncm91bmQgMC41cywgY29sb3IgMC41cztcbn1cbi5lcnJvcmJhY2tkZyB7XG4gIGJhY2tncm91bmQ6IHZhcigtLWlvbi1jb2xvci1kYW5nZXItdGludCkgIWltcG9ydGFudDtcbn1cbi53YXJuaW5nYmFja2RnIHtcbiAgYmFja2dyb3VuZDogdmFyKC0taW9uLWNvbG9yLXByaW1hcnktdGludCkgIWltcG9ydGFudDtcbn1cblxuLmluc2V0IHtcbiAgYm9yZGVyLXN0eWxlOiBpbnNldDtcbiAgYm9yZGVyLXdpZHRoOiAycHg7XG4gIGJvcmRlci1yYWRpdXM6IDEwcHg7XG4gIG1hcmdpbi1ib3R0b206IDEwcHg7XG4gIHBhZGRpbmc6IDEwcHg7XG59XG5cbmlvbi1zZWxlY3Qge1xuICBoZWlnaHQ6IDU1cHg7XG4gIGJvcmRlci13aWR0aDogM3B4ICFpbXBvcnRhbnQ7XG59XG5cbmlvbi1idXR0b24ge1xuICBtYXgtd2lkdGg6IDI2MHB4O1xuICBtYXJnaW4tbGVmdDogYXV0bztcbiAgbWFyZ2luLXJpZ2h0OiBhdXRvO1xufVxuXG4vLyBpb24taXRlbSB7XG4vLyAgIC0taW9uLWl0ZW0tYmFja2dyb3VuZDogI2ZmZmZmZiAhaW1wb3J0YW50O1xuLy8gICBib3JkZXItd2lkdGg6IDJweDtcbi8vICAgYm9yZGVyLXN0eWxlOiBzb2xpZDtcbi8vICAgYm9yZGVyLWNvbG9yOiAjZmZiZTAwO1xuLy8gfVxuXG5pb24tdG9nZ2xlIHtcbiAgLS1iYWNrZ3JvdW5kOiAjOWM5YzljO1xuICAtLWJhY2tncm91bmQtY2hlY2tlZDogIzAwYTliZjcxO1xuXG4gIC0taGFuZGxlLWJhY2tncm91bmQ6IHdoaXRlO1xuICAtLWhhbmRsZS1iYWNrZ3JvdW5kLWNoZWNrZWQ6ICMwMGE5YmY7XG59XG5cbi5zaG9ydC1kZXNjcmlwdGlvbi10ZXh0YXJlYSB7XG4gIGhlaWdodDogODhweDtcbiAgbWluLWhlaWdodDogODhweDtcbiAgbWF4LWhlaWdodDogODhweDtcbn1cblxuLmFjdGl2aXR5LWRlc2NyaXB0aW9uLXRleHRhcmVhIHtcbiAgbWluLWhlaWdodDogODhweDtcbn1cblxuLmpvYi1kZXNjcmlwdGlvbi10ZXh0YXJlYSB7XG4gIG1pbi1oZWlnaHQ6IDEzMnB4O1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/pages/dbjobs/addjob/addjob.page.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AACA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kCAAA;AAEF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE,eAAA;AAIF;;AAFA;EACE,yCAAA;EACA,uCAAA;EACA,uCAAA;AAKF;;AAHA;EACE,mBAAA;EACA,8BAAA;EACA,uCAAA;AAMF;;AAJA;EACE,mDAAA;AAOF;;AALA;EACE,oDAAA;AAQF;;AALA;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAQF;;AALA;EACE,YAAA;EACA,4BAAA;AAQF;;AALA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAQF;;AAEA;EACE,qBAAA;EACA,+BAAA;EAEA,0BAAA;EACA,oCAAA;AAAF;;AAGA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;AACA,g3FAAg3F","sourcesContent":["ion-label {\n  z-index: 10;\n}\nion-item {\n  border-radius: 8px;\n  border-width: 2px;\n  border-style: solid;\n  border-color: #ffbe00;\n  background-color: white !important;\n}\n.popover-content {\n  width: 457px !important;\n}\n.showpointer {\n  cursor: pointer;\n}\n.iconBtn:hover {\n  background: var(--ion-color-danger-shade);\n  color: var(--ion-color-medium-contrast);\n  transition: background 0.1s, color 0.1s;\n}\n.iconBtn {\n  border-radius: 1rem;\n  color: var(--ion-color-danger);\n  transition: background 0.5s, color 0.5s;\n}\n.errorbackdg {\n  background: var(--ion-color-danger-tint) !important;\n}\n.warningbackdg {\n  background: var(--ion-color-primary-tint) !important;\n}\n\n.inset {\n  border-style: inset;\n  border-width: 2px;\n  border-radius: 10px;\n  margin-bottom: 10px;\n  padding: 10px;\n}\n\nion-select {\n  height: 55px;\n  border-width: 3px !important;\n}\n\nion-button {\n  max-width: 260px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n// ion-item {\n//   --ion-item-background: #ffffff !important;\n//   border-width: 2px;\n//   border-style: solid;\n//   border-color: #ffbe00;\n// }\n\nion-toggle {\n  --background: #9c9c9c;\n  --background-checked: #00a9bf71;\n\n  --handle-background: white;\n  --handle-background-checked: #00a9bf;\n}\n\n.short-description-textarea {\n  height: 88px;\n  min-height: 88px;\n  max-height: 88px;\n}\n\n.activity-description-textarea {\n  min-height: 88px;\n}\n\n.job-description-textarea {\n  min-height: 132px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
